import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './app/router';
import './assets/styles.css';

function setupDevtoolsDeterrent() {
  if (
    !import.meta.env.PROD ||
    import.meta.env.VITE_SECURITY_DEVTOOLS_DETERRENT !== 'true'
  ) {
    return;
  }

  const blockedKeys = new Set(['F12']);
  document.addEventListener('contextmenu', (event) => event.preventDefault());
  document.addEventListener('keydown', (event) => {
    const key = event.key.toUpperCase();
    const isDevtoolsShortcut =
      blockedKeys.has(event.key) ||
      ((event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        ['C', 'I', 'J'].includes(key)) ||
      ((event.ctrlKey || event.metaKey) && key === 'U');

    if (isDevtoolsShortcut) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}

setupDevtoolsDeterrent();

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
